import {EXTRA_ITEM_BINDING_CONTEXT_TYPE_ID} from './identifiers';

import type {
  BindingContextTypeDef,
  BindablePropertiesDef,
  TypeReferenceBuilder,
} from '@packages/systems/dynamo/source-types';

export const extraItemType: BindingContextTypeDef = {
  entity: 'Entity',
  id: EXTRA_ITEM_BINDING_CONTEXT_TYPE_ID,
  label: 'Extra Items',
  pluralLabel: 'Extra Items',
  singularLabel: 'Extra Item',
  iconName: 'product',
};

export function extraItemBindableProperties<RootTRef, EntityTRef, ListTRef>(
  typeReferenceBuilder: TypeReferenceBuilder<RootTRef, EntityTRef, ListTRef>
): BindablePropertiesDef<EntityTRef, ListTRef> {
  return {
    type: typeReferenceBuilder.entityOf({
      entity: 'Entity',
      id: EXTRA_ITEM_BINDING_CONTEXT_TYPE_ID,
    }),
    bindableProperties: [
      {
        id: 'extra-item-name',
        type: 'PlainText',
        label: 'Name',
        path: [{id: '', slug: 'name', type: 'PlainText'}],
        queryPath: [],
        meta: {
          singleLine: true,
          minLength: null,
          maxLength: null,
          required: true,
        },
        rendering: {strategy: 'client'},
      },
      {
        id: 'extra-item-price',
        type: 'CommercePrice',
        label: 'Price',
        path: [{id: '', slug: 'price', type: 'CommercePrice'}],
        queryPath: [],
        meta: {required: true},
        rendering: {strategy: 'client'},
      },
    ],
  };
}
